module.exports = __webpack_public_path__ + "static/media/lsa.64791e06.png";